import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { audienceCards } from '../../data/artTherapy';
const tones = {
  peach: {
    card: 'bg-peach border-[#F6D9CF]',
    tag: 'border-[#F3C7B8] bg-[#FDECE5] text-coral'
  },
  lavender: {
    card: 'bg-[#FAF5FE] border-lavender-line',
    tag: 'border-lavender-line bg-lavender-soft text-lavender-deep'
  }
};
export function AudienceFit() {
  return <section aria-labelledby="audience-title" className="bg-white py-14 md:py-20" data-id="element-1" data-mp="1pqsn1q1onj7f">
      <div className="mx-auto max-w-5xl px-5" data-id="element-2" data-mp="1kt0mk7mz2orm">
        <SectionTitle id="audience-title" underline data-id="element-3" data-mp="1gqnh7kc50svd">
          Több mint 150 tevékenység. Kétféle felhasználás.
        </SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-4" data-mp="1bqrf5qn03big">
          {audienceCards.map(c => <article key={c.tag} className={`rounded-3xl border p-6 ${tones[c.tone].card}`} data-id="element-5" data-mp="5crzc3tum60g">
              <span className="text-3xl" aria-hidden="true" data-id="element-6" data-mp="bm70743okrg">
                {c.emoji}
              </span>
              <span className={`mt-3 block w-fit rounded-full border px-4 py-1.5 text-[13px] font-extrabold uppercase tracking-[0.1em] ${tones[c.tone].tag}`} data-id="element-7" data-mp="2efuef482uztw">
                {c.tag}
              </span>
              <h3 className="mt-3 font-display text-xl font-bold leading-tight text-ink" data-id="element-8" data-mp="25fyxsjvr6cmh">{c.title}</h3>
              <ul className="mt-3 space-y-2.5" data-id="element-9" data-mp="2aesdmiyiifpt">
                {c.points.map(p => <li key={p} className="flex gap-3 text-[17px] leading-snug text-body" data-id="element-10" data-mp="1vlykhuqbi12o">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ok" strokeWidth={2.5} aria-hidden="true" data-id="element-11" data-mp="20g2t0if8eh5v" />
                    {p}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-[16px] font-semibold leading-relaxed text-body" data-id="element-12" data-mp="1cpgylty5gvec">
          Mindkettőben magadra ismersz? Ugyanaz a kézikönyv tevékenységeket kínál a saját nyugodt pillanataidhoz és a
          másokkal végzett munkához is.
        </p>
      </div>
    </section>;
}